import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';


const firebaseConfig = {
    apiKey: "AIzaSyDzQc0hRAUsWVkdWmz9IvolqjlO73TFDC4",
    authDomain: "react-demo-28e06.firebaseapp.com",
    databaseURL: "https://react-demo-28e06-default-rtdb.firebaseio.com",
    projectId: "react-demo-28e06",
    storageBucket: "react-demo-28e06.appspot.com",
    messagingSenderId: "971219019841",
    appId: "1:971219019841:web:10585edddfe55ef6b3fec0",
    measurementId: "G-GL514CSZC0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// export default getFirestore();
  export const db = getFirestore(app);
